import _ from 'lodash';
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { fetchRelatedArticle } from './action-related-article';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return {
    type: types.REQUEST_ARTICLE,
    payload: undefined,
  };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return {
    type: types.RECEIVE_ARTICLE_ERROR,
    payload: undefined,
  };
}

function fetchArticle(faqId) {
  return (dispatch) => {
    dispatch(requestArticle());
    const faq = _.split(faqId, ',')[0];
    return axios.get(`${ARTICLE_URL}?article_id=${faq}`, {
      cancelToken: source.token,
    })
    .then(response => (
      dispatch(receiveArticle(response.data.articleContent))
    ))
    .catch(() => (
      dispatch(receiveArticleError())
    ));
  };
}

function cancelArtilceRequest() {
  source.cancel('article request canceled.');
}

function fetchArticleCombination(faqId) {
  return (dispatch) => {
    dispatch(requestArticle());
    const faq = _.split(faqId, ',')[0];
    return axios.get(`${ARTICLE_URL}?article_id=${faq}`)
    .then((response) => {
      dispatch(receiveArticle(response.data.articleContent));
      dispatch(fetchRelatedArticle(response.data.articleContent.articleTitle));
    })
    .catch(() => (
      dispatch(receiveArticleError())
    ));
  };
}

module.exports = {
  receiveArticleError,
  fetchArticle,
  fetchArticleCombination,
  cancelArtilceRequest,
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-article.js